import { render, staticRenderFns } from "./SymbolsSection.vue?vue&type=template&id=1f56b87b&"
import script from "./SymbolsSection.vue?vue&type=script&lang=ts&"
export * from "./SymbolsSection.vue?vue&type=script&lang=ts&"
import style0 from "./SymbolsSection.vue?vue&type=style&index=0&id=1f56b87b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports